(() => {
  const bindPurchaseActions = (root) => {
    if (root.dataset.pdpPurchaseActionsBound === 'true') return;

    const buyNowButton = root.querySelector('[data-pdp-gokwik-buy-now]');
    if (!buyNowButton) return;

    root.dataset.pdpPurchaseActionsBound = 'true';

    buyNowButton.addEventListener('click', () => {
      const form = root.closest('product-form')?.querySelector('form[data-type="add-to-cart-form"]');
      if (!form || typeof window.onBuyNowClick !== 'function') return;

      const positionSelect = form.querySelector('#text--position');
      const engravingInput = form.querySelector('#engraving');

      if (engravingInput && !engravingInput.disabled) {
        engravingInput.value = engravingInput.value.toUpperCase().replace(/[^A-Z ]/g, '');
      }

      const isNoEngraving = !positionSelect || !positionSelect.value || positionSelect.value === 'No Engraving';
      const engraving = engravingInput && !engravingInput.disabled ? engravingInput.value.trim() : '';
      const engravingPosition = !isNoEngraving ? positionSelect.value.trim() : '';

      if (!isNoEngraving && !engraving) {
        if (engravingInput) {
          engravingInput.disabled = false;
          engravingInput.focus();
        }
        if (!form.reportValidity()) return;
      }

      const variantId = form.querySelector('[name="id"]')?.value;

      if (variantId && engraving && engravingPosition) {
        const properties = {
          engraving,
          'Engraving Postion': engravingPosition,
        };

        window.onBuyNowClick(buyNowButton, false, [{
          id: variantId,
          quantity: '1',
          properties,
        }]);
        return;
      }

      window.onBuyNowClick(buyNowButton);
    });
  };

  const initializePurchaseActions = () => {
    document.querySelectorAll('[data-pdp-purchase-actions]').forEach(bindPurchaseActions);
  };

  document.addEventListener('shopify:section:load', initializePurchaseActions);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePurchaseActions, { once: true });
  } else {
    initializePurchaseActions();
  }
})();
